import React from "react";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";
import AssignDialog from "./assignDialog";
import useEvaluationProcessDefinitionAssignment from "./useTrainingAssignment";

const AssignmentPage = (props) => {

  const {
    training,
    handleClose,
  } = props;

  const {
    isLoading,
    canAssign,
    assignedCollaborators,
    collaboratorsList,
    state,
    handlers,
  } = useEvaluationProcessDefinitionAssignment(training.id);

  const goBackButton = () => (
    <CustomIconButton
      title={getLocalizedString("goBack")}
      onClick={handleClose}
      type={"goBack"}
    />
  )

  const createButton = () => canAssign && (
    <CustomIconButton
      title={getLocalizedString("assignCollaborators")}
      onClick={() => handlers.handleOpenCreateDialog()}
      type={"add"}
    />
  )

  const deleteButton = (gridRef) => canAssign && (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteDialog(gridRef)}
      type={"delete"}
    />
  )

  return (
    <CommonPage
      isLoading={isLoading}
      title={getLocalizedString("assignEmployeesToTrainingWithTrainingName", { trainingName: training.name })}
      gridTitle={getLocalizedString("assignEmployeesToTrainingWithTrainingName", { trainingName: training.name })}
      columnDefPage={"/training/assignment"}
      rowData={assignedCollaborators}
      menuItems={[goBackButton, createButton, deleteButton]}
      hasExpand
      hasHelp
      ignoreProcessesbyPath
    >
      {
        state.createDialogIsOpen &&
        <AssignDialog
          open={state.createDialogIsOpen}
          data={assignedCollaborators}
          collaboratorsList={collaboratorsList}
          trainingName={training.name}
          isLoading={isLoading}
          handleAssign={handlers.handleAssign}
          handleClose={handlers.handleCloseCreateDialog}
        />
      }
    </CommonPage>
  )
}

export default AssignmentPage;